import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../configs/urlConfig"; // tvoj API base URL
import Utils from "../utils";
import Musterije from "../components/Musterije";
import ShowDate from "../components/ShowDate";

axios.defaults.withCredentials = true;

function ByDateAll() {
  const { date } = useParams(); // uzima datum iz URL-a
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [showModalDatum, setShowModalDatum] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError("");

        // šaljemo datum u backend
        const response = await axios.get(
          `${API}/bydate-all/`,
          Utils.getUserToken(),
        );
        setData(response.data); // pretpostavljam da backend vraća objekat sa poljem "payouts"
      } catch (err) {
        console.error(err);
        setError("Greška prilikom dohvata podataka");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading)
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        Učitavanje...
      </div>
    );

  if (error)
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <p className="text-danger">{error}</p>
      </div>
    );

  if (!data || !data.payouts)
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <p>Nema podataka</p>
      </div>
    );

  return (
    <div className="container mt-2">
      {data.payouts.length > 0 && (
        <>
          {data.payouts.map((payout, key) => {
            console.log("payout", data.payouts.length, key + 1);
            return (
              <div key={key}>
                <div
                  className="d-flex justify-content-between align-items-center w-100"
                  style={{ fontSize: "13px" }}
                >
                  <div style={{ width: "33%" }}></div>
                  <div style={{ width: "33%" }} className="text-center">
                    {payout.day}
                  </div>
                  <div style={{ width: "33%", textAlign: "right" }}>
                    <small>{Utils.formatirajBroj(payout.total_payout)}</small>
                  </div>
                </div>

                <Musterije
                  data={{ payouts: payout.customers }}
                  setData={setData}
                  allDate={data?.payouts?.length === key + 1}
                />
                <div
                  style={{ borderTop: "2px solid #000", marginBottom: "3px" }}
                />
              </div>
            );
          })}
        </>
      )}
      <div
        className="d-flex justify-content-center align-items-center w-100"
        style={{
          zIndex: 20,
          position: "fixed",
          left: 0,
          bottom: 0,
          backgroundColor: "white",
          padding: "10px",
        }}
      >
        <button
          type="button"
          className="btn btn-primary btn-sm desktop-add-btn"
          onClick={() => navigate("/")}
        >
          Home
        </button>
      </div>
    </div>
  );
}

export default ByDateAll;
